/* Project Import will be here */
import * as actions from '../actions/timeCardDatas.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
let initialState = {
    timeCardData: {
        project: null,
        taskCode: null,
        hours: "",
        startTime: "",
        endTime: "",
        lunchStartTime: "",
        lunchEndTime: "",
        shift: null,
        payCode: null
    }
};

/* Const,Let & Var will be here */

export default function (state = initialState, action) {
    switch (action.type) {
        case actions.TIME_CARD_DATAS:
            return {
                ...state,
                timeCardData: {
                    ...state.timeCardData,
                    project: action.project,
                    taskCode: action.taskCode,
                    hours: action.hours,
                    startTime: action.startTime,
                    endTime: action.endTime,
                    lunchStartTime: action.lunchStartTime,
                    lunchEndTime: action.lunchEndTime,
                    shift: action.shift,
                    payCode: action.payCode
                }
            };

        default:
            return state;
    }
}